import React from 'react';
import DetailedHeader from '../../../../components/ProjectDetailedPageComponents/DetailedHeader';
import Seo from '../../../../components/Misc/Seo';
import ImageSlider from '../../../../components/Misc/ImageSlider';
import projectImage1 from '../../../../assets/images/work/agnico-eagle-experience/AgnicoEagleExperience_Slider_1.webp';
import projectImage2 from '../../../../assets/images/work/agnico-eagle-experience/AgnicoEagleExperience_Slider_2.webp';
import projectImage3 from '../../../../assets/images/work/agnico-eagle-experience/AgnicoEagleExperience_Slider_3.webp';
import projectImage4 from '../../../../assets/images/work/agnico-eagle-experience/AgnicoEagleExperience_Slider_4.webp';
import projectImage5 from '../../../../assets/images/work/agnico-eagle-experience/AgnicoEagleExperience_Slider_5.webp';

import Data_AgnicoEagleExperience from './Data_AgnicoEagleExperience';

function Work_AgnicoEagleExperience() {
    const canonical = 'https://studio.norcat.org/OurWork/agnico-eagle-experience';
    const title = 'Agnico Eagle 360 Experience | Studio NORCAT - Driven by experiences that matter.';
    const description = 'Developed by Studio NORCAT, the Agnico Eagle 360 Experience guides viewers through the mining lifecycle with immersive 360 video storytelling designed for engagement, orientation, and public education.';

    return (
        <>
            <Seo
                title={title}
                description={description}
                canonical={canonical}
                ogTitle={title}
                ogDescription={description}
                ogImage={`${window.location.origin}${projectImage1}`}
                ogImageAlt="Preview of the Agnico Eagle 360 Experience project"
                twitterTitle={title}
                twitterDescription={description}
                twitterImage={`${window.location.origin}${projectImage1}`}
                twitterImageAlt="Preview of the Agnico Eagle 360 Experience project"
            />
            <DetailedHeader
                heading="Explore the Mining Lifecycle from Every Angle"
                client="Agnico Eagle"
                service="Virtual 360 Experience"
                date="2026"
            />
            <ImageSlider
                noArt="true"
                swiperNav="true"
                useButtonNav="true"
                youtubeUrl="https://www.youtube.com/watch?v=RJ91jHcOdt8"
                images={[
                    {
                        image: projectImage1,
                        alt: 'Agnico Eagle 360 Experience project screenshot 1',
                    },
                    {
                        image: projectImage2,
                        alt: 'Agnico Eagle 360 Experience project screenshot 2',
                    },
                    {
                        image: projectImage3,
                        alt: 'Agnico Eagle 360 Experience project screenshot 3',
                    },
                    {
                        image: projectImage4,
                        alt: 'Agnico Eagle 360 Experience project screenshot 4',
                    },
                    {
                        image: projectImage5,
                        alt: 'Agnico Eagle 360 Experience project screenshot 5',
                    },
                ]}
            />

            {Data_AgnicoEagleExperience.content}
        </>
    );
}

export default Work_AgnicoEagleExperience;
